import { LegalPage, type LegalSection } from './LegalPage';

const SECTIONS: LegalSection[] = [
  {
    heading: 'Try before you pay',
    body: [
      'Every new business starts with a 7-day free trial. No card is needed and nothing is charged during the trial, so you can decide before any money changes hands.',
    ],
  },
  {
    heading: 'Monthly and yearly plans',
    body: [
      'Subscriptions are paid in advance for the period you choose (monthly or yearly), in Bangladeshi Taka.',
      'If you cancel, your plan stays active until the end of the period you already paid for. We do not auto-charge a cancelled plan for the next period.',
    ],
  },
  {
    heading: 'When we give refunds',
    body: [
      'If you were charged in error — for example, billed twice for the same period — we refund the incorrect charge in full.',
      'If the service was unavailable for an extended, verified outage caused by us, we credit or refund a fair share of the affected period.',
      'Within 7 days of your first paid charge, if Possignin is not right for you, contact us and we will refund that first payment.',
    ],
  },
  {
    heading: 'When we usually don’t',
    body: [
      'We generally do not refund a period that has already been used, or a yearly plan part-way through, beyond the cases above.',
      'Add-ons and one-time purchases (such as SMS packs) are non-refundable once delivered.',
    ],
  },
  {
    heading: 'How refunds are made',
    body: [
      'Online payments made through SSLCommerz are refunded to the original card or wallet; this can take a few business days to appear, depending on your bank.',
      'Cash payments are refunded by bank transfer or cash at our Sylhet office.',
    ],
  },
  {
    heading: 'How to request',
    body: [
      'Email support@itcitysoft.com from your account email with your business name and the charge in question. We respond within 2 business days.',
    ],
  },
];

export function Refund() {
  return (
    <LegalPage
      title="Refund Policy"
      updated="14 June 2026"
      intro="Fair and clear: a free trial first, refunds when we get billing wrong, and no surprises."
      sections={SECTIONS}
    />
  );
}
